<!-- Main container -->
<div class="department">
    <div class="department__main custom-scrollbar" [ngClass]="{ department__main_loading: state == 'loading' }">
        <p-table
            class="main__table"
            #maintable
            [value]="departments"
            [showCurrentPageReport]="false"
            dataKey="id"
            [expandedRowKeys]="expandedItems"
        >
            <ng-template pTemplate="caption">
                <div class="input-wrapper input-wrapper_high" [ngClass]="{ 'input-wrapper_disabled': isControlsDisabled() || isFiltersDisabled() }">
                    <input
                        class="input"
                        [(ngModel)]="filterField"
                        (input)="filterDepartments()"
                        type="search"
                        inputmode="search"
                        placeholder="חפש  טיפול"
                        [disabled]="isControlsDisabled() || isFiltersDisabled()"
                        autocomplete="off"
                    />
                </div>
            </ng-template>

            <!-- Strip -->
            <ng-template pTemplate="body" let-rowData let-expanded="expanded">
                <div
                    class="data__row"
                    [ngClass]="{ data__row_expanded: expanded, data__row_checked: hasDepartmentCheckedServices(rowData) }"
                    (click)="onStripExpand(rowData)"
                >
                    <i class="fa-solid" [ngClass]="expanded ? 'fa-chevron-down' : 'fa-chevron-left'"></i>
                    <span class="row__name">{{ rowData.name }}</span>
                </div>
            </ng-template>

            <!-- Substrip -->
            <ng-template pTemplate="rowexpansion" let-rowData>
                <div class="table__table-info">
                    <div
                        *ngFor="let strip of rowData.services"
                        class="table-info__strip"
                        [ngClass]="{ 'table-info__strip_subscribe': strip.isSubscriber }"
                        (click)="toggleService(strip)"
                    >
                        <div class="strip__checkbox">
                            <input class="checkbox" type="checkbox" [ngModel]="isServiceChecked(strip)" />
                            <span class="custom-checkbox"></span>
                        </div>

                        <div class="strip__info strip-info">
                            <div class="strip-info__name">{{ strip.serviceName }}</div>

                            <div class="strip-info__description strip-description">
                                <div class="strip-description__time">
                                    <i class="time__icon fa-regular fa-clock-two-thirty"></i>
                                    <span class="time__text">{{ strip.timeService }} דק׳</span>
                                </div>

                                <div class="strip-description__price">
                                    <i class="price__icon fa-regular fa-coins"></i>
                                    <span class="price__currency">₪</span>
                                    <span class="price__text">{{ strip.priceService }}</span>
                                </div>

                                <div *ngIf="strip.subT" class="strip-description__subscription">
                                    <img class="subscription__icon" src="/assets/img/ticket.svg" />
                                    <span class="subscription__text">{{ strip.sub }}/{{ strip.subT }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-table>

        <!-- Empty services list -->
        <div *ngIf="state == 'nodepartments'" class="department__empty-wrapper">
            <h3 class="department__empty-title">אין עדיין טיפולים במחלקה</h3>

            <span class="department__empty-text">
                להוספת טיפולים, היכנסו בתפריט הראשי/העליון להגדרות -> ”טיפולים ומחלקות”, ולחצו על ה
                <span class="department__empty-plus">+</span>
            </span>

            <span class="department__empty-image"></span>
        </div>

        <!-- Empty search result list -->
        <div *ngIf="state == 'noresults'" class="department__empty-wrapper department__empty-wrapper_no-result">
            <h3 class="department__empty-title">
                אופסס... נראה שאין לכם טיפול בשם <span class="department__empty-filter">{{ filterField }}</span>
            </h3>

            <span class="department__empty-text">ייתכן שיש טעות באיות, נסה לתקן ולחפש מחדש</span>

            <span class="department__empty-image"></span>
        </div>

        <div *ngIf="state == 'noresults'" class="department__helper">
            <span class="department__helper-title">חסרים לכם טיפולים?</span>

            <span class="department__helper-text">
                להוספת טיפולים, היכנסו בתפריט הראשי/העליון להגדרות -> ”טיפולים ומחלקות”, ולחצו על ה
                <span class="department__helper-plus">+</span>
            </span>
        </div>
    </div>

    <!-- Choosed services list -->
    <div *ngIf="choosedServices.length" class="department-main__info-block">
        <div class="info-block__choosed" [ngClass]="{ 'info-block__choosed_full': isErrorVisible }">
            <div class="choosed__header">נבחרו:</div>

            <div class="choosed__table choosed-table custom-scrollbar">
                <div *ngFor="let item of choosedServices" class="choosed-table__row choosed-row">
                    <span class="choosed-row__name">{{ item.serviceName }}</span>

                    <div class="choosed-row__details">
                        <div class="details__time">
                            <i class="time__icon fa-regular fa-clock-two-thirty"></i>
                            <span class="time__text">{{ item.timeService }} דק׳</span>
                        </div>

                        <div class="details__price">
                            <i class="price__icon fa-regular fa-coins"></i>
                            <span class="price__currency">₪</span>
                            <span class="price__text">{{ item.priceService }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Full time error -->
        <div *ngIf="isErrorVisible" class="info-block__error">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <div class="error__text error-text">
                <span class="error-text__alarm">שימו לב!</span>
                <span>הטיפולים שבחרתם חורגים מהזמן הפנוי ביומן כרגע ({{ maxAvailableTime }} דק’)</span>
            </div>
        </div>
    </div>

    <!-- Loader -->
    <div *ngIf="state == 'loading'" class="department__loader-wrapper">
        <span class="department__loader-text">טוען מאגר טיפולים...</span>
        <span class="department__loader"></span>
    </div>
</div>
